import { screenSizeSwitch } from '../../../../../lib/helpers';
import BigTrustpilot from './BigTrustpilot';
import SmallTrustpilot from './SmallTrustpilot';

export default screenSizeSwitch([[991, SmallTrustpilot], BigTrustpilot]);
